/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CandidateExternalProcessStatusDto = {
    MarkedAsSent: 'MARKED_AS_SENT',
    NotApplicable: 'NOT_APPLICABLE',
    NotSent: 'NOT_SENT',
    Sent: 'SENT'
} as const;

export type CandidateExternalProcessStatusDto = typeof CandidateExternalProcessStatusDto[keyof typeof CandidateExternalProcessStatusDto];



